import { useTaskData } from 'setup-guide-components/hooks/task';
export const useHasMinimumTaskGroupAmount = () => {
  const {
    taskGroups = []
  } = useTaskData();
  return taskGroups.length > 0;
};